import { render, staticRenderFns } from "./default-course.vue?vue&type=template&id=3fbb37f0&scoped=true&"
import script from "./default-course.vue?vue&type=script&lang=js&"
export * from "./default-course.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbb37f0",
  null
  
)

export default component.exports